let company = 'Bedrijfsnaam';
let name = 'Henk van Veen';
let street = 'Teststraat 23 A';
let postal = '1234 AB';
let city = 'Amsterdam';
let country = 'Nederland';
let orderFrom = 'Bestelling van piqwise.com';
let labelType = '30323';
let postalStamp = false;

//todo: naar class ombouwen

function labelXml() {
	if (labelType === '30323') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30323();
	} else if (labelType === '30321') {
		// eslint-disable-next-line no-use-before-define
		return Dymo30321();
	}
}

function getAddressString() {
	let addressString = '';

	if (company) {
		addressString += company + '\n';
	}

	if (name) {
		addressString += name + '\n';
	}

	if (street) {
		addressString += street + '\n';
	}

	if (postal) {
		addressString += postal + ' ';
	}

	if (city) {
		addressString += city + '\n';
	}

	if (country) {
		addressString += country + '\n';
	}

	return addressString;
}

function Dymo30323() {
	if (postalStamp) {
		// eslint-disable-next-line no-use-before-define
		return Dymo30323WithPostalStamp();
	}

	// eslint-disable-next-line no-use-before-define
	return Dymo30323WithoutPostalStamp();
}

function Dymo30323WithoutPostalStamp() {
	let Dymo30323 = null;
	try {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/address/30323.xml');
	} catch (error) {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/address/30323.xml');
	}

	return Dymo30323;
}

function Dymo30323WithPostalStamp() {
	let Dymo30323 = null;
	try {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/address/postnlstamp/30323.xml');
	} catch (error) {
		Dymo30323 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/address/postnlstamp/30323.xml');
	}

	return Dymo30323;
}

function Dymo30321() {
	if (postalStamp) {
		return Dymo30321WithPostalStamp();
	}

	return Dymo30321WithoutPostalStamp();
}

function Dymo30321WithoutPostalStamp() {
	let Dymo30321 = null;
	try {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/address/30321.xml');
	} catch (error) {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/address/30321.xml');
	}

	return Dymo30321;
}

function Dymo30321WithPostalStamp() {
	let Dymo30321 = null;
	try {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dls/address/postnlstamp/30321.xml');
	} catch (error) {
		Dymo30321 = dymo.label.framework.openLabelFile(process.env.VUE_APP_BASE_URL + 'dymo/labels/dcd/address/postnlstamp/30321.xml');
	}

	return Dymo30321;
}

function createLabel() {
	const label = labelXml();

	label.setObjectText('address', getAddressString());
	label.setObjectText('bottomText', orderFrom);

	return label;
}

export default {
	getCompany() {
		return company;
	},
	setCompany(newCompany) {
		company = newCompany;
	},
	getName() {
		return name;
	},
	setName(newName) {
		name = newName;
	},
	getStreet() {
		return street;
	},
	setStreet(newStreet) {
		street = newStreet;
	},
	getPostal() {
		return postal;
	},
	setPostal(newPostal) {
		postal = newPostal;
	},
	getCity() {
		return city;
	},
	setCity(newCity) {
		city = newCity;
	},
	getCountry() {
		return country;
	},
	setCountry(newCountry) {
		country = newCountry;
	},
	getOrderFrom() {
		return orderFrom;
	},
	setOrderFrom(newOrderFrom) {
		orderFrom = newOrderFrom;
	},
	getLabelType() {
		return labelType;
	},
	setLabelType(newLabelType) {
		labelType = newLabelType;
	},
	getPostalStamp() {
		return postalStamp;
	},
	setPostalStamp(newPostalStamp) {
		postalStamp = newPostalStamp;
	},
	getLabel: createLabel,
}
